import { render, staticRenderFns } from "./DownloadNotifications.vue?vue&type=template&id=ffbaaf46&scoped=true&"
import script from "./DownloadNotifications.vue?vue&type=script&lang=js&"
export * from "./DownloadNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DownloadNotifications.vue?vue&type=style&index=0&id=ffbaaf46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbaaf46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
